import { Component, OnInit, OnDestroy, ViewChild, Inject, ElementRef } from '@angular/core';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { ClienteService } from 'src/app/services/cliente.service';
import { TokenSolicitado } from 'src/app/models/token-solicitado';
import { FuncionarioService } from 'src/app/services/funcionario.service';
import { GlobalService } from 'src/app/services/global.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { CRMHierarquiaUsuarioService } from 'src/app/services/crmhierarquia-usuario.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MatPaginator, PageEvent, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Filtro } from 'src/app/models/filtro';
import { PaginatorService } from 'src/app/services/paginator.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';

@Component({
  selector: 'app-solicitacoes-token-integrador-modal',
  templateUrl: './solicitacoes-token-integrador-modal.component.html',
  styleUrls: ['./solicitacoes-token-integrador-modal.component.scss']
})
export class SolicitacoesTokenIntegradorModalComponent implements OnInit {
  solicitacoes: TokenSolicitado[] = [];
  statusSolicitacaoSelecionado = 1;
  public config: PerfectScrollbarConfigInterface = {};
  filtroNome: Filtro = { Propriedade: 'nome', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  tiposDeStatusSolicitacao = [
    { id: -1, nome: 'Todos' }
    ,{ id: 1, nome: 'Solicitado' }
    ,{ id: 2, nome: 'Aprovado' }
    ,{ id: 3, nome: 'Reprovado' }
    ,{ id: 4, nome: 'Bloqueado' }
    ,{ id: 5, nome: 'Liberado' }
  ];
  @ViewChild('paginator', { static: false }) paginator: MatPaginator;
  paginacao: any;
  listaDeItensPorPagina: any;
  itensPorPagina: any;
  campoOrdenacao = 'dataSolicitacao';
  ordenarDesc = false;
  trocarRazaoPorNomeFantasia = false;
  administrador = false;
  idSolicitacaoToken?: number;

  constructor(
    private clienteService: ClienteService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private funcionarioService: FuncionarioService,
    private globalService: GlobalService,
    private premissasService: PremissasService,
    private hierarquiaService: CRMHierarquiaUsuarioService,
    public dialogRef: MatDialogRef<SolicitacoesTokenIntegradorModalComponent>,
    private paginatorService: PaginatorService,
    private utilitarioService: UtilitarioService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  async ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();
    this.administrador = await this.globalService.administrador();

    this.paginacao = pagination.paginacao;
    this.paginacao.total = 0;

    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    if (this.data) {
      this.idSolicitacaoToken = this.data.idSolicitacaoToken;
    }

    this.buscarSolicitacoes();
    this.buscarTrocarRazaoPorNomeFantasia();
  }

  filtra() {
    this.idSolicitacaoToken = null;
    this.buscarSolicitacoes();
    this.paginator.firstPage();
  }

  montaVM() {
    this.filtros = [];
    this.filtros.push(this.filtroNome);
    this.filtros = this.filtros.filter(f => f.Valor !== undefined && f.Valor !== null && f.Valor !== '');

    if (this.idSolicitacaoToken) {
      this.filtros.push({ Propriedade: 'idSolicitacaoToken', Valor: this.idSolicitacaoToken });
    }

    const vm = {
      filtros: this.filtros,
      paginacao: this.paginacao,
      ordenarDesc: this.ordenarDesc,
      campoOrdenacao: this.campoOrdenacao,
      itensPorPagina: this.itensPorPagina,
      statusSolicitacao: this.statusSolicitacaoSelecionado
    };

    return vm;
  }

  buscarSolicitacoes() {
    const vm = this.montaVM();

    this.carregandoService.mostra('buscarSolicitacoes');
    this.clienteService.consultarListaTokensSolicitados(vm).subscribe(
      res => {
        this.carregandoService.esconde('buscarSolicitacoes');
        this.solicitacoes = res.solicitacoes;
        this.paginacao.total = res.total;
      },
      err => {
        this.carregandoService.esconde('buscarSolicitacoes');
        this.notificacaoService.erro(err);
      }
    );
  }

  aprovarSolicitacao(solicitacao: TokenSolicitado) {
    this.carregandoService.mostra('aprovarSolicitacao');
    this.clienteService.aprovarSolicitacao(solicitacao.id).subscribe(
      res => {
        this.carregandoService.esconde('aprovarSolicitacao');
        this.notificacaoService.sucesso('Solicitação aprovada com sucesso!');
        this.buscarSolicitacoes();
      },
      err => {
        this.carregandoService.esconde('aprovarSolicitacao');
        this.notificacaoService.erro(err);
      }
    );
  }

  liberarSolicitacao(solicitacao: TokenSolicitado) {
    this.carregandoService.mostra('liberarSolicitacao');
    this.clienteService.liberarSolicitacao(solicitacao.id).subscribe(
      res => {
        this.carregandoService.esconde('liberarSolicitacao');
        this.notificacaoService.sucesso('Solicitação aprovada com sucesso!');
        this.buscarSolicitacoes();
      },
      err => {
        this.carregandoService.esconde('liberarSolicitacao');
        this.notificacaoService.erro(err);
      }
    );
  }

  reprovarSolicitacao(solicitacao: TokenSolicitado) {
    this.carregandoService.mostra('reprovarSolicitacao');
    this.clienteService.reprovarSolicitacao(solicitacao.id).subscribe(
      res => {
        this.carregandoService.esconde('reprovarSolicitacao');
        this.notificacaoService.sucesso('Solicitação reprovada com sucesso!');
        this.buscarSolicitacoes();
      },
      err => {
        this.carregandoService.esconde('reprovarSolicitacao');
        this.notificacaoService.erro(err);
      }
    );
  }

  bloquearSolicitacao(solicitacao: TokenSolicitado) {
    this.carregandoService.mostra('bloquearSolicitacao');
    this.clienteService.bloquearSolicitacao(solicitacao.id).subscribe(
      res => {
        this.carregandoService.esconde('bloquearSolicitacao');
        this.notificacaoService.sucesso('Solicitação bloqueada com sucesso!');
        this.buscarSolicitacoes();
      },
      err => {
        this.carregandoService.esconde('bloquearSolicitacao');
        this.notificacaoService.erro(err);
      }
    );
  }

  exportarSolicitacoesToken() {
    const vm = this.montaVM();

    this.carregandoService.mostra('exportaSolicitacoes');

    this.clienteService.exportarSolicitacoesToken(vm).subscribe(data => {
      this.carregandoService.esconde('exportaSolicitacoes');
      this.utilitarioService.saveBlob(data, 'SolicitaçõesToken.xlsx');
    }, (erro) => {
      console.error(erro);
      this.carregandoService.esconde('exportaSolicitacoes');
      this.notificacaoService.erro('Não foi possível exportar as solicitações de token.');
    });
  }

  buscarTrocarRazaoPorNomeFantasia() {
    this.carregandoService.mostra('buscarTrocarRazaoPorNomeFantasia');
    this.premissasService.consultarTrocarRazaoPorNomeFantasia().subscribe(fg => {
      if (fg.valor) {
        this.trocarRazaoPorNomeFantasia = fg;
      }

      this.carregandoService.esconde('buscarTrocarRazaoPorNomeFantasia');
    }, (erro) => {
      this.carregandoService.esconde('buscarTrocarRazaoPorNomeFantasia');
      this.notificacaoService.erro(erro);
    });
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarSolicitacoes();
  }

  fechar() {
    this.dialogRef.close();
  }

}
